import React from "react";
import {Button, Icon, Text} from "@reside/ui";
import {useNavigate} from "react-router-dom";

export const BackButton = ({
  removeResident,
}: {
  removeResident: () => void;
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <>
      <Button
        type="link"
        style={{marginTop: "5px"}}
        onClick={() => {
          removeResident();
          navigate("/admin/residents");
        }}
      >
        <Icon name="left" size={15} color="primary" />
      </Button>
      <Text>Resident Profile</Text>
    </>
  );
};
